import $ from 'jquery';
import Counter from './generic/counter';
import SessionStoragePop from './generic/SessionStoragePop';
import MethodUtils from './generic/methodUtils';

const ALERT_PRO_DEFAULT_VALUES = {
    URL_SERVICE : "/icd/ape/data/alertes-compteur.json",
    URL_SIGNATURE : "/com/icd-web/alerting/fil-alertes.html",
    SESSION_KEY: "alert_pro_counter",
    MOBILE_BREAKPOINT : 768
}

const ALERT_PRO_SELECTOR = {
    ID_COUNTER: '#js-link-alert-counter',
    DATA_CHANNEL_ALERTING_PRO: "li[data-channelid='c30c27583a2dc610VgnVCM100000da4658c0RCRD'] a",
    DATA_CHANNEL_ALERTING_ENT: "li[data-channelid='9587227b02e6d610VgnVCM100000da4658c0RCRD'] a"
}

export default class AlertingProApp {

    constructor() {
        var _self = this;

        _self.counterEmpty = true;

        // init default values
        _self.urlService = ALERT_PRO_DEFAULT_VALUES.URL_SERVICE;
        _self.sessionKey = ALERT_PRO_DEFAULT_VALUES.SESSION_KEY;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new SessionStoragePop(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new MethodUtils();

        // Custom channel ID
        if ( $( ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_PRO ).length ) {
            _self.counterSelector = ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_PRO;
        } else if( $(ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_ENT).length){
            _self.counterSelector = ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_ENT;
        }else{
            _self.urlService = null;
        }

        // Init Popin & counter
        _self.counter = new Counter(_self.counterSelector);

        _self.isInRefreshingMode = true;

        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode)
                _self.updateNotification()
        }, _self.intervalTime);

        _self.updateNotification()
    }

    initPropertiesFromConf() {
        this.intervalTime = window.cmsGlobals.alertingProConfig.intervalTime;
        if (window.cmsGlobals.alertingProConfig.urlAlertingSignature) {
            this.urlAlertingProSignature = window.cmsGlobals.alertingProConfig.urlAlertingSignature;
        } else {
            this.urlAlertingProSignature = ALERT_PRO_DEFAULT_VALUES.URL_SIGNATURE;
        }
    }


    launchTimer(data, appliFunction, time) {
        if (data !== null) {
            setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
        }
        return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
    }

    /**
     * Get the value from the session storage, if no value, call Alerting service
     */
    updateNotification() {
        var _self = this;
        if (_self.urlAlertingProSignature.indexOf(window.location.pathname) !== -1) {
            _self.sessionStoragePop.resetCounterInSession();
            _self.updateDOM();
        } else {
            _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

            if (!_self.dataResponse) {
                _self.callAlertingProService();
            } else {
                if ( (new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                    _self.updateDOM();
                } else {
                    _self.callAlertingProService();
                }
            }
        }
    }

    /**
     * Call the service exposed by Alerting in order to recover the notification numbers
     */
    callAlertingProService() {
        var _self = this;

        if(_self.urlService != null){
            $.ajax( {
                url:_self.urlService,
                method: "GET",
                swmIntercept: false,
                contentType : "application/xml; charset=utf-8",
                dataType: 'json',
                beforeSend: function(request) {
                    request.setRequestHeader("x-no-session-postpone", "true");
                },
                success: function (response) {
                    if (response && response.commun.statut.toLowerCase() === "ok") {
                        _self.dataResponse = {};
                        _self.dataResponse.counterVal = response.donnees.compteur;

                        if (_self.dataResponse.counterVal !== null && _self.dataResponse.counterVal !== 0) {
                            _self.sessionStoragePop.updateCounterAlone(_self.dataResponse.counterVal, false);
                            _self.updateDOM();
                        }
                    } else {
                        _self.isInRefreshingMode = false;
                        _self.sessionStoragePop.removeKey();
                    }
                },
                error:  function () {
                    _self.isInRefreshingMode = false;
                    _self.sessionStoragePop.removeKey();
                    console.error("Erreur réseau");
                }
            });
        }else{
            _self.isInRefreshingMode = false;
            _self.sessionStoragePop.removeKey();
        }
    }

    /**
     * Update the html for both counter and infobulle
     */
    updateDOM() {
        var _self = this;
        var data = _self.sessionStoragePop.getJsonObjectFromSession();

        // Update Counter
        _self.counter.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
    }

}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/alerting_pro.js